import * as bt from "@/utils/behaviorTracker";

const HANDLER_KEYS = {
  touchstart: "___bt_onTouchStart",
  scroll: "___bt_onScroll",
  input: "___bt_onInput",
  focus: "___bt_onFocus",
  keydown: "___bt_onKeyDown",
};

export default {
  mounted() {
    const step = this.$options.__behaviorStep;
    if (step) bt.startStep(step);

    this[HANDLER_KEYS.touchstart] = (e) => {
      if (e.touches && e.touches.length) {
        bt.recordTouch(e.touches[0].clientX, e.touches[0].clientY, Date.now());
      }
    };
    this[HANDLER_KEYS.scroll] = () => bt.recordScroll();
    this[HANDLER_KEYS.input] = (e) => {
      const name = e.target.name || e.target.placeholder || e.target.type || "unknown";
      bt.recordInput(name, Date.now());
    };
    this[HANDLER_KEYS.focus] = (e) => {
      const name = e.target.name || e.target.placeholder || e.target.type || "unknown";
      bt.recordFocusChange(name, Date.now());
    };
    this[HANDLER_KEYS.keydown] = (e) => {
      if (e.key === "Backspace" || e.key === "Delete") {
        bt.recordBackspace();
      }
    };

    window.addEventListener("touchstart", this[HANDLER_KEYS.touchstart], { passive: true });
    window.addEventListener("scroll", this[HANDLER_KEYS.scroll], { passive: true });

    this.$nextTick(() => {
      const fields = this.$el.querySelectorAll("input, textarea");
      fields.forEach((el) => {
        el.addEventListener("input", this[HANDLER_KEYS.input]);
        el.addEventListener("focus", this[HANDLER_KEYS.focus]);
        el.addEventListener("keydown", this[HANDLER_KEYS.keydown]);
      });
    });
  },

  beforeDestroy() {
    const step = this.$options.__behaviorStep;
    if (step) bt.endStep(step);

    window.removeEventListener("touchstart", this[HANDLER_KEYS.touchstart]);
    window.removeEventListener("scroll", this[HANDLER_KEYS.scroll]);

    const fields = this.$el.querySelectorAll("input, textarea");
    fields.forEach((el) => {
      el.removeEventListener("input", this[HANDLER_KEYS.input]);
      el.removeEventListener("focus", this[HANDLER_KEYS.focus]);
      el.removeEventListener("keydown", this[HANDLER_KEYS.keydown]);
    });
  },
};
